package one.healthium.insights.data.utils

import one.healthium.insights.data.dto.ActionDto
import one.healthium.insights.data.dto.ContentEntryDto
import one.healthium.insights.data.dto.MealPlanResponseDto

internal class CustomSerializerModules {

    val modules = listOf(
        ContentEntryDto.module,
        ActionDto.module,
        MealPlanResponseDto.module
    )
}